import React from 'react';
import styled from 'styled-components';
import HBCheckbox from '../HBCheckbox/HBCheckbox';

interface Props<T> {
    item: T;
    itemId: string;
    isItemSelected: boolean;
    onSelectItem: (item: T, isSelected: boolean) => void;
    testIdName?: string;
}

const HBNewTableRowCheckbox = <T,>({
    item,
    itemId,
    isItemSelected,
    onSelectItem,
    testIdName
}: Props<T>) => {
    return (
        <NewTableStyledCheckboxWrapper
            key={`select-wrapper-${itemId}`}
            onClick={e => e.stopPropagation()}
        >
            <HBCheckbox
                testIdName={testIdName ?? 'table-row-select'}
                checked={isItemSelected}
                onChange={e => onSelectItem(item, e.target.checked)}
                size="sm"
            />
        </NewTableStyledCheckboxWrapper>
    );
};

export default React.memo(HBNewTableRowCheckbox);

// -------------------------------- Styles -------------------------------- //
const NewTableStyledCheckboxWrapper = styled.div`
    line-height: 0;
`;
